<template>
  <div class="market-container">
    <template v-if="!errormsg">
      <div id="market-charts"
           :style="{height: '389px', width: '742px'}">

      </div>
      <div class="verbal-trick">{{ lastdate || '' }}，热点情绪指标为{{ hottype.lbl }}；市场高度为{{ hottype.gdb }}；<span v-show="!errormsg && hottype.msg">市场{{ hottype.msg }}。</span> </div>
    </template>
    <div class="empty-state"
         v-else>
      <img src="//i.thsi.cn/images/level2/hottrack/20190227/empty_state.png">
      <span>{{ errormsg }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarketSentiment',
  data() {
    return {
      mChart: null,
      gdb: [],
      lbl: [],
      date: [],
      hottype: {},
      errormsg: null
    };
  },
  mounted() {
    this.getData();
    this.gethottype();
  },
  computed: {
    lastdate() {
      if (!this.date[this.date.length - 1]) {
        return '';
      }
      return Acme.formatDate(new Date(this.date[this.date.length - 1]), 'yyyy年MM月dd日');
    }
  },
  methods: {
    getData() {
      const s = this;
      this.$api.marketAPI
        .getEmotioncycle()
        .then(res => {
          if (res.data.errorcode == 0 && res.data.result) {
            s.gdb = res.data.result.gdb.data;
            s.date = res.data.result.date;
            s.lbl = res.data.result.lbl.data;
            s.errormsg = 0;
            s.mChart = echarts.init(document.getElementById('market-charts'));
            s.draw();
          } else {
            s.errormsg = '暂无数据';
          }
        })
        .catch(error => {
          s.errormsg = '暂无数据';
        });
    },
    gethottype() {
      this.$api.marketAPI.gethottype().then(res => {
        if (res.data.errorcode == 0 && res.data.result) {
          this.hottype = res.data.result;
        }
      });
    },
    draw() {
      let _this = this;

      let option = {
        grid: {
          left: '5%',
          right: '6%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#283b56'
            }
          },
          textStyle: {
            align: 'left'
          }
        },
        legend: {
          data: ['高度板', '情绪指标']
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            showMinLabel: true,
            showMaxLabel: true,
            interval: Math.floor(_this.date.length / 5),
            color: '#ADACAC'
          },
          data: _this.date,
          axisLine: {
            lineStyle: {
              color: '#ADACAC'
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            color: '#ADACAC'
          },
          axisLine: {
            lineStyle: {
              color: '#ADACAC'
            }
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            data: _this.gdb,
            type: 'bar',
            name: '高度板',
            // barWidth: '50%',
            itemStyle: {
              color: '#DB4741'
            }
          },
          {
            type: 'line',
            data: _this.lbl,
            name: '情绪指标',
            lineStyle: {
              color: '#0068B7'
            },
            itemStyle: {
              borderColor: '#0068B7'
            },
            color: '#0068B7',
            markArea: {
              data: [
                [
                  {
                    yAxis: 0,
                    itemStyle: {
                      color: '#b6dccf'
                    }
                  },
                  {
                    yAxis: 3
                  }
                ],
                [
                  {
                    yAxis: 3,
                    itemStyle: {
                      color: '#d8e5c9'
                    }
                  },
                  {
                    yAxis: 4
                  }
                ],
                [
                  {
                    yAxis: 4,
                    itemStyle: {
                      color: '#fad5a9'
                    }
                  },
                  {
                    yAxis: 8
                  }
                ],
                [
                  {
                    yAxis: 8,
                    itemStyle: {
                      color: '#f8beb2'
                    }
                  },
                  {
                    yAxis: 30
                  }
                ]
              ]
            }
          }
        ]
        // dataZoom: [
        //   {
        //     id: 'dataZoomX',
        //     type: 'slider',
        //     xAxisIndex: [0],
        //     filterMode: 'filter',
        //     bottom: '0%',
        //     showDetail: false,
        //     startValue: 30
        //   }
        // ]
      };
      this.mChart.setOption(option);
    }
  }
};
</script>

<style scoped>
.market-container {
  height: 489px;
  width: 742px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 15px 10px;
}

.verbal-trick {
  font-size: 14px;
  color: #1b1b1b;
  line-height: 20px;
  padding: 20px 5% 0 5%;
  text-align: left;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #bbb;
  height: 100%;
  width: 100%;
  flex-direction: column;
  font-size: 12px;
}

.empty-state img {
  margin: 0 0 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/MarketSentiment.vue